$(window).load(function() {
  $( ".beadPic" ).draggable({
  revert: "invalid",
  cursor: "grab",
  stack: ".draggable",
  helper: 'clone',
  appendTo: '#customGrey',
  start: function( event, ui ) {
  },
    stop: function( event, ui ) {
  countBeads();
 }
  });
  $('.dropper').droppable({
accept: ".beadPic",
drop: function(event, ui) {
  $(this).html('');
  $('#cartForm').removeClass('vizzi');
  $('#putBox').css('display','block');
  var droppable = $(this);
  droppable.removeClass('dropped');
  var draggable = ui.draggable;
  var drag = $('.droppable').has(ui.draggable).length ? draggable : draggable.clone().draggable({
    revert: "invalid",
  cursor: "grab",
    stack: ".draggable",
    helper: 'clone',
  appendTo: '#customGrey',
    stop: function( event, ui ) {
  },
  });
  drag.appendTo(droppable);
  setTimeout(function(){
    droppable.addClass('dropped');
    countBeads();
  }, 20);
  draggable.css({
  });
}
});

// Make beads on the bracelet draggable
$('.dropper').on('mousedown', '.beadPic', function() {
    $(this).draggable({
        revert: "invalid",
        stack: ".draggable",
        cursor: "grab",
        helper: 'clone',
        appendTo: '#customGrey'
    });
});

// Make the trash can droppable
$('#trashCan').droppable({
    accept: ".beadPic",
    drop: function(event, ui) {
        var droppable = ui.draggable.parent();
        ui.draggable.remove();
        droppable.removeClass('dropped');
        countBeads();
    }
});

// Ensure the trash can is always visible
$('#trashCan').show();
} );

function switchStyle(clazz,sty) {
console.log('men switch');
  closeThis();
  $('.oneStyle').removeClass('activated');
  $(sty).addClass('activated');
  $('#beadSizeBock').removeClass('yesser');
  $('#colorBock').removeClass('yesser');
  $('#lockBox').html('loading...');
  $('#parker').html('loading...');
  $('#potHolder').attr('class',clazz);
  $('#sheller').attr('class',clazz);
  $('#cartForm').removeClass('vizzi');
  $('#putBox').css('display','block');
  switch(clazz) {
  case 'Classic':
    $('#colorBock').html('STRING COLOR');
    $('#lockBock').html('LOCK STYLE');
    sizeThis('classic_medium8');
    metaThis('Classic', 'Medium (17cm / 6.7”)', 'S02 (Black)', 'LK02 (18K Gold Plated)');
    beadSize('8mm','classic_medium8');
    pullBeads('beadList8');
    priceUpdate(229);
    $('#beadSizeBock').addClass('yesser');
    break;
  case 'Outside Strung':
    $('#colorBock').html('STRING COLOR');
    $('#lockBock').html('LOCK STYLE');
    sizeThis('strung_medium');
    metaThis('Classic With String', 'Medium (17cm / 6.7”)', 'S02 (Black)', 'LK02 (18K Gold Plated)');
    pullBeads('beadList10h');
    priceUpdate(229);
    break;
  case 'Elastic':
    $('#colorBock').html('STRING COLOR');
    $('#lockBock').html('NIALAYA LOGO BEAD');
    sizeThis('elastic_medium8');
    metaThis('Elastic', 'Medium (17cm / 6.7”)', 'S02 (Black)', 'LK02 (18K Gold Plated)');
    beadSize('8mm','elastic_medium8');
    pullBeads('beadList8');
    priceUpdate(119);
    $('#beadSizeBock').addClass('yesser');
    $('#colorBock').addClass('yesser');
    break;
  case 'Leather Wrap Around':
    $('#colorBock').html('LEATHER COLOR');
    $('#lockBock').html('LOCK STYLE');
    sizeThis('leather_wrap');
    metaThis('Leather Wrap-Around', 'Medium (17cm / 6.7”)', 'L2 (Black)', 'LK02 (18K Gold Plated)');
    priceUpdate(179);
    break;
case 'Leather Anchor':
    $('#colorBock').html('LEATHER COLOR');
    $('#lockBock').html('LOCK STYLE');
    sizeThis('leather_anchor');
    metaThis('Leather Anchor', 'Medium (17cm / 6.7”)', 'L2 (Black)', 'LK02 (18K Gold Plated)');
    priceUpdate(259);
    break;      
case 'Leather Big Clasp':
    $('#colorBock').html('LEATHER COLOR');
    $('#lockBock').html('LOCK STYLE');
    sizeThis('leather_bigclasp');
    metaThis('Leather Big Clasp', 'Medium (17cm / 6.7”)', 'L2 (Black)', 'LK02 (18K Gold Plated)');
    priceUpdate(259);
    break;
case 'Leather Big Hook':
    $('#colorBock').html('LEATHER COLOR');
    $('#lockBock').html('LOCK STYLE');
    sizeThis('leather_bighook');
    metaThis('Leather Bali Clasp', 'Medium (17cm / 6.7”)', 'L2 (Black)', 'LK02 (18K Gold Plated)');
    priceUpdate(259);
    break;
case 'Stingray':
    $('#colorBock').html('LEATHER COLOR');
    $('#lockBock').html('LOCK STYLE');
    sizeThis('stingray');
    metaThis('Stingray', 'Medium (17cm / 6.7”)', 'SR02 (Black)', 'LK02 (18K Gold Plated)');
    priceUpdate(159);
    break;
case 'Necklace':
    $('#colorBock').html('NECKLACE');
    $('#lockBock').html('OPTIONS?');
    sizeThis('necklace');
    metaThis('Necklace', 'size for necklaces', 'ID and descriptor', 'lock style');
    priceUpdate(999);
    break;
  } 
}

function womenSwitchStyle(clazz,sty) {
  closeThis();
  $('.oneStyle').removeClass('activated');
  $(sty).addClass('activated');
  $('#beadSizeBock').removeClass('yesser');
  $('#colorBock').removeClass('yesser');
  $('#lockBox').html('loading...');
  $('#parker').html('loading...');
  $('#potHolder').attr('class',clazz);
  $('#sheller').attr('class',clazz);
  $('#cartForm').removeClass('vizzi');
  $('#putBox').css('display','block');
  switch(clazz) {
    case 'Classic':
      $('#colorBock').html('STRING COLOR');
      $('#lockBock').html('LOCK STYLE');
      sizeThis('classic_medium8_women');
      metaThis('Classic', 'Medium (16cm / 6.3”)', 'S02 (Black)', 'LK02 (18K Gold Plated)');
      beadSize('8mm','classic_medium8_women');
      pullBeads('beadList8');
      priceUpdate(229);
      $('#beadSizeBock').addClass('yesser');
      break;
    case 'Outside Strung':
      $('#colorBock').html('STRING COLOR');
      $('#lockBock').html('LOCK STYLE');
      sizeThis('strung_medium_women');
      metaThis('Classic With String', 'Medium (16cm / 6.3”)', 'S02 (Black)', 'LK02 (18K Gold Plated)');
      pullBeads('beadList10h');
      priceUpdate(229);
      break;
    case 'Elastic':
      $('#colorBock').html('STRING COLOR');
      $('#lockBock').html('NIALAYA LOGO BEAD');
      sizeThis('elastic_medium8_women');
      metaThis('Elastic', 'Medium (16cm / 6.3”)', 'S02 (Black)', 'LK02 (18K Gold Plated)');
      beadSize('8mm','elastic_medium8_women');
      pullBeads('beadList8');
      priceUpdate(119);
      $('#beadSizeBock').addClass('yesser');
      $('#colorBock').addClass('yesser');
      break;
    case 'Leather Wrap Around':
      $('#colorBock').html('LEATHER COLOR');
      $('#lockBock').html('LOCK STYLE');
      sizeThis('leather_wrap_women');
      metaThis('Leather Wrap-Around', 'Medium (16cm / 6.3”)', 'L2 (Black)', 'LK02 (18K Gold Plated)');
      priceUpdate(179);
      break;
    case 'Leather Anchor':
      $('#colorBock').html('LEATHER COLOR');
      $('#lockBock').html('LOCK STYLE');
      sizeThis('leather_anchor_women');
      metaThis('Leather Anchor', 'Medium (16cm / 6.3”)', 'L2 (Black)', 'LK02 (18K Gold Plated)');
      priceUpdate(259);
      break;      
    case 'Leather Big Clasp':
      $('#colorBock').html('LEATHER COLOR');
      $('#lockBock').html('LOCK STYLE');
      sizeThis('leather_bigclasp_women');
      metaThis('Leather Big Clasp', 'Medium (16cm / 6.3”)', 'L2 (Black)', 'LK02 (18K Gold Plated)');
      priceUpdate(259);
      break;
    case 'Leather Big Hook':
      $('#colorBock').html('LEATHER COLOR');
      $('#lockBock').html('LOCK STYLE');
      sizeThis('leather_bighook_women');
      metaThis('Leather Bali Clasp', 'Medium (16cm / 6.3”)', 'L2 (Black)', 'LK02 (18K Gold Plated)');
      priceUpdate(259);
      break;
    case 'Stingray':
      $('#colorBock').html('LEATHER COLOR');
      $('#lockBock').html('LOCK STYLE');
      sizeThis('stingray_women');
      metaThis('Stingray', 'Medium (16cm / 6.3”)', 'SR02 (Black)', 'LK02 (18K Gold Plated)');
      priceUpdate(159);
      break;
  } 
}
function bringBeads() {
$('.swinger').removeClass('shugMe');
  $('#beadBox').addClass('shugMe');
  $([document.documentElement, document.body]).animate({
      scrollTop: $("#leftWing").offset().top
  }, 1000);
}

function bringThis(el) {
$('.swinger').removeClass('shugMe');
  $(el).addClass('shugMe');
  $([document.documentElement, document.body]).animate({
      scrollTop: $("#leftWing").offset().top
  }, 1000);
}

function closeThis(el) {
  $('.swinger').removeClass('shugMe');
}

function countBeads() {
  var notAll = 0;
  var setter = 0;
var pricelet = parseInt($('#basePriceTag').html());
$('.dropper').each(function( index ) {
    if($( this ).hasClass('dropped')) {
      if(setter==0) {
      $('#infoTag').html('<div class="beadStock"><div>ID</div><div>Name</div><div>Price</div></div>');    
      }
      setter = 1;
      var idNumber = $( this ).find('.beadPic img').attr('name');
      var beadPrice = $( this ).find('.beadPic img').attr('price');
      pricelet = pricelet+parseInt($( this ).find('.beadPic img').attr('price'));
      $('#infoTag').append('<div class="beadStock purple'+idNumber+'"><div>'+idNumber+'</div><div>'+beadMeta[idNumber]+'</div><div>'+beadPrice+'</div></div>');
    } else {
      notAll = 1;
    }
});
  if(notAll==0) {
    $('#cartForm').addClass('vizzi');
  }
console.log('pricelet: '+pricelet);
  pricelet += '';
x = pricelet.split('.');
x1 = x[0];
x2 = x.length > 1 ? '.' + x[1] : '';
var rgx = /(\d+)(\d{3})/;
while (rgx.test(x1)) {
  x1 = x1.replace(rgx, '$1' + ',' + '$2');
}
pricelet = x1 + x2;
    $('#priceCount').html(pricelet);
}
var beadMeta = [];
$( document ).ready(function() {
$('.oneBead').each(function( index ) {
  beadMeta[$(this).find('.beadPic img').attr('name')] = $(this).find('h4').html();
});
  if ($(window).width()<=768) {
  $('#leftWing').prepend($('#cartForm'));
  $('#leftWing').prepend($('#priceBox'));
}

});
function resetBeadArray() {
$('.oneBead').each(function( index ) {
  beadMeta[$(this).find('.beadPic img').attr('name')] = $(this).find('h4').html();
});
}
$(window).resize(function() {
if ($(window).width()<=768) {
  $('#leftWing').prepend($('#cartForm'));
  $('#leftWing').prepend($('#priceBox'));
} else {
  $('#metaTrail').append($('#priceBox'));
  $('#metaTrail').append($('#cartForm'));
}
});

function makeid(length) {
 var result           = '';
 var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
 var charactersLength = characters.length;
 for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
 }
 return result;
}

function sizeThis(clazz) {
  $('#sizeTag').addClass('highlight');
  setTimeout(function(){
  $('#sizeTag').removeClass('highlight');
}, 1000);
closeThis();
  $('#infoTag').html('');
  $('#lockBox').html('loading...');
  $('#parker').html('loading...');
  $('#parker').attr('class',clazz);
  $('.oneBead').each(function( index ) {
    if($(this).hasClass('hovert')) {
    $(this).attr('class','oneBead hovert '+clazz);
    } else {
    $(this).attr('class','oneBead '+clazz);
    }
  });
  $('#customGrey').attr('class','user-content row-spacing '+clazz);
  $('#cartForm').removeClass('vizzi');
  $('#putBox').css('display','block');
   var dataString = { 
            pull: clazz+'.php'
          };        
         $.ajax({
           type: "POST",
           data: dataString,
           url: "/apps/udesign/fetch.php",
           success: function(response) {
             $('#parker').html(response);
             reDrop();
             countBeads();
           }
         });  
         $.ajax({
           type: "POST",
           data: dataString,
           url: "/apps/udesign/fetchLocks.php",
           success: function(response) {
             $('#lockBox').html(response);
             countBeads();
           }
         });  
         $.ajax({
           type: "POST",
           data: dataString,
           url: "/apps/udesign/fetchColors.php",
           success: function(response) {
             $('#colorBox').html(response);
             countBeads();
           }
         });  
         $.ajax({
           type: "POST",
           data: dataString,
           url: "/apps/udesign/fetchSize.php",
           success: function(response) {
             $('#sizeBox').html(response);
             countBeads();
           }
         });  
}

function beadSize(snork,jazz) {
    $('#beadSizeTag').html(snork);
    var dataString = { 
            pull: jazz+'.php'
          };        
      $.ajax({
           type: "POST",
           data: dataString,
           url: "/apps/udesign/fetchBeadSize.php",
           success: function(response) {
             $('#sizeBeadsBox').html(response);
             countBeads();
           }
         });  
}
function pullBeads(jazz) {
    var dataString = { 
            pull: jazz+'.php'
          };        
      $.ajax({
           type: "POST",
           data: dataString,
           url: "/apps/udesign/fetchBeadList.php",
           success: function(response) {
             $('#beadPuller').html(response);
             countBeads();
             reDrop();
             resetBeadArray();
           }
         });  
}


function activateThis(el) {
$('.swinger').removeClass('shugMe');
$(el).parent().parent().find('h4').removeClass('activated');
$(el).addClass('activated');
}
function metaThis(sty,siz,col,peng) {
$('#styleTag').html(sty);
$('#sizeTag').html(siz);
$('#colorTag').html(col);
$('#lockTag').html(peng);
}
function lockThis(urz, peng) {
$('#lockTag').addClass('highlight');
  setTimeout(function(){
  $('#lockTag').removeClass('highlight');
}, 1000);
  $('#lockEr').attr('src',urz);
  $('#cartForm').removeClass('vizzi');
  $('#putBox').css('display','block');
  $('#lockTag').html(peng);
  countBeads();
}
function priceUpdate(urz) {
  $('#basePriceTag').addClass('highlight');
  setTimeout(function(){
  $('#basePriceTag').removeClass('highlight');
}, 1000);
$('#priceCount').html(urz);
  $('#basePriceTag').html(urz);
}

function colorThis(urz, col) {
  $('#colorTag').addClass('highlight');
  setTimeout(function(){
  $('#colorTag').removeClass('highlight');
}, 1000);
$('#emBrace').attr('src',urz);
  $('#cartForm').removeClass('vizzi');
  $('#putBox').css('display','block');
$('#colorTag').html(col);
  countBeads();
}
function baseThis(urz) {
  $('#baseEr').attr('src',urz);
}

function reDrop() {
  $('#cartForm').removeClass('vizzi');
  $('#putBox').css('display','block');
  $( ".beadPic" ).draggable({
  revert: "invalid",
  stack: ".draggable",
cursor: "grab",
  helper: 'clone',
  appendTo: '#customGrey',
//     cursorAt: { left: 41, top: 41 },
  start: function( event, ui ) {
    if(window.devicePixelRatio == 2) {
//       $(this).draggable('instance').offset.click = {
//         left: -90,
//         top: -40
//     };
    }
  },
    stop: function( event, ui ) {
  countBeads();
 }
  });
  $('.dropper').droppable({
accept: ".beadPic",
drop: function(event, ui) {
  $(this).html('');
  var droppable = $(this);
  droppable.removeClass('dropped');
  var draggable = ui.draggable;
  // Move draggable into droppable
  var drag = $('.droppable').has(ui.draggable).length ? draggable : draggable.clone().draggable({
    revert: "invalid",
    stack: ".draggable",
    cursor: "grab",
    helper: 'clone',
  appendTo: '#customGrey',
//       cursorAt: { left: 41, top: 41 },
    stop: function( event, ui ) {
  },
  });
  drag.appendTo(droppable);
  setTimeout(function(){
    droppable.addClass('dropped');
    countBeads();
  }, 20);
  draggable.css({
  });
}
});
}
$(document).on('click', '.oneColor', function(){
  $(this).parent().find('.oneColor').removeClass('activated');
  $(this).addClass('activated');
});
$(document).on('click', '.oneLock', function(){
  $(this).parent().find('.oneLock').removeClass('activated');
  $(this).addClass('activated');
});
$(window).load(function() {
 $('#potHolder').fadeIn('slow');
});